export default __webpack_public_path__ + "static/media/330_store05-nl-web.154a36bb.png";